export const TOGGLE_FETCHING_DOCUMENTS = "TOGGLE_FETCHING_DOCUMENTS";
export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const SET_SELECTED_ACCOUNT = "SET_SELECTED_ACCOUNT";
